var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "telegram",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 501.65 501.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M-545.2,966.84v220.68A140.48,140.48,0,0,1-685.68,1328H-924.37a122.47,122.47,0,0,1-122.48-122.47V966.84A140.49,140.49,0,0,1-906.37,826.36h220.69A140.49,140.49,0,0,1-545.2,966.84",
    transform: "translate(1046.85 -826.36)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-956.87,1076.05l241.78-101.92a16.18,16.18,0,0,1,22.28,17.38L-722.21,1182a20.83,20.83,0,0,1-32.26,14.08l-86.64-58.56a12.91,12.91,0,0,1-1.71-20l82.22-78.84a5,5,0,0,0-.26-7.41,5,5,0,0,0-5.95-.3l-108.92,73.27a39,39,0,0,1-33.46,4.85L-956,1094.34a9.75,9.75,0,0,1-.86-18.29",
    transform: "translate(1046.85 -826.36)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f84b595815e3cb923fd8aba859793b69.svg";
export { ForwardRef as ReactComponent };